var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Accordion, AccordionDetails, AccordionSummary, Chip, Divider, Grid, IconButton, TextField, Typography, useMediaQuery } from '@mui/material';
import { GridAddIcon, GridRemoveIcon } from '@mui/x-data-grid-premium';
import { t } from 'i18next';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { CheckAlterNatePartsUrl, CheckRepeatUrl, checkModelWisePeriodicPartURL, deleteRepeatChildsURL, saveDeclinedPmPartsURl } from '../../../../api/url';
import { ChevronRightIcon, ReverseActionIcon, RoundClearIcon } from '../../../../assets/customIcons';
import { InputBox, MuiButton, MuiStack } from '../../../../components';
import { MuiCheckBox } from '../../../../components/atoms/checkBox';
import { MuiIconButton } from '../../../../components/atoms/iconButtonComponent';
import { MuiLoaderButton } from '../../../../components/atoms/loaderButton';
import { MuiSelectComponent } from '../../../../components/atoms/muiSelectComponent';
import SkeletonLoader from '../../../../components/atoms/sketeton';
import { AlternatePartRelations, EJobItemType, EModuleSection, EParentModuleName, LOCAL_STORAGE_KEYS } from '../../../../constants';
import { setIsTaskDetailsDataUpdated, setSavedTaskDetailsCount, setTaskDetailsDataSaved, setUpdatedModuleSectionByChannel, showLoader, showNotification } from '../../../../redux/commonSlice';
import { createAPI, getListAPI, setState } from '../../../../redux/crudSlice';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import Colors from '../../../../theme/colors';
import { getLocalStorageItem } from '../../../../utils/storageHelper';
import useAnalyticsEventTracker from '../../../../utils/useAnalyticsEventTracker';
import { getSupersadeAlternatePartMessage } from '../../../../utils/utils';
import AlternatePartPopup from '../../../jobCard/revisedEstimate/taskDetailAccordians/alternatePartPopup';
import PartLabourDetailsDrawer from './partLabourDetailsDrawer';
import { systemColor } from '../../../../theme/systemColor';
var PeriodicMaintainanceComponent = function (props) {
    var trackButtonClick = useAnalyticsEventTracker("PeriodicMaintainanceComponent");
    var parentModuleDocumentId = props.parentModuleDocumentId, getSavedPeriodicPartsUrl = props.getSavedPeriodicPartsUrl, parentModuleName = props.parentModuleName, upsertPMPartsUrl = props.upsertPMPartsUrl, callApIStatus = props.callApIStatus, _a = props.isSaveButton, isSaveButton = _a === void 0 ? true : _a, isDisabled = props.isDisabled, SystemName = props.SystemName, alternatePartConfigState = props.alternatePartConfigState, declinedPmPartsList = props.declinedPmPartsList, pmPartsMasterList = props.pmPartsMasterList, rejectReasonRemarkList = props.rejectReasonRemarkList, setDeclinedPmPartsList = props.setDeclinedPmPartsList, setPmPartsMasterList = props.setPmPartsMasterList, setRejectReasonRemarkList = props.setRejectReasonRemarkList, pmPartsList = props.pmPartsList, setpmPartsList = props.setpmPartsList, isSkeleton = props.isSkeleton, setIsSkeleton = props.setIsSkeleton, showRepeatItems = props.showRepeatItems;
    var _b = useSelector(function (state) { return state.crud; }), ModuleDetailsGetById = _b.ModuleDetailsGetById, TaskDetailsSectionSave = _b.TaskDetailsSectionSave, getModuleHeaderCount = _b.getModuleHeaderCount, repeatAlertConfiguration = _b.repeatAlertConfiguration;
    var updatedModuleSectionByChannel = useSelector(function (state) { return state.common; }).updatedModuleSectionByChannel;
    var declinedJobsConfiguration = getLocalStorageItem(LOCAL_STORAGE_KEYS.DECLINED_JOB_CONFIGURATION);
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var dispatch = useAppDispatch();
    var _c = useState(false), disableSave = _c[0], setDisableSave = _c[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _d = useState(false), alternetPartPopupOpen = _d[0], setAlternetPartPopupOpen = _d[1];
    var _e = useState([]), alterNatePartDetails = _e[0], setAlterNatePartDetails = _e[1];
    var _f = useState(null), searchedPart = _f[0], setSearchedPart = _f[1];
    var IS_DESKTOP = useMediaQuery(function (theme) { return theme.breakpoints.up("md"); });
    var _g = useState(null), isOpenJobItemDetailsDrawer = _g[0], setIsOpenJobItemDetailsDrawer = _g[1];
    var _h = useState(null), selectedJobItemDetails = _h[0], setSelectedJobItemDetails = _h[1];
    var replacePart = function () {
        var alterNatePartItem = alterNatePartDetails.find(function (item) { return item.isChecked; });
        var list = __spreadArray([], pmPartsList, true);
        if (alterNatePartItem) {
            var result = [];
            for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
                var element = list_1[_i];
                if (element.ChildId === (searchedPart === null || searchedPart === void 0 ? void 0 : searchedPart.ChildId)) {
                    result.push(_objectSpread(_objectSpread({}, element), {}, {
                        ChildId: alterNatePartItem.PartId,
                        PartName: alterNatePartItem.PartName,
                        HasAlternatePart: alterNatePartItem.AssociationName === AlternatePartRelations.TwoWay
                    }));
                }
                else {
                    result.push(element);
                }
            }
            setpmPartsList(result);
        }
        setAlternetPartPopupOpen(false);
    };
    // useEffect(() => {
    //   if (callApIStatus) {
    //     // initiate()
    //   }
    // }, [callApIStatus])
    // const initiate = async () => {
    //   try {
    //     dispatch(showLoader({ isLoaderOpen: true }));
    //     await Promise.all([
    //       getRejectRemarkList(),
    //       getProductWisePmParts()
    //     ]);
    //     dispatch(showLoader({ isLoaderOpen: false }));
    //   } catch (error) {
    //     dispatch(showLoader({ isLoaderOpen: false }));
    //     console.log("error : initiate in PeriodicMaintainanceComponent", error)
    //   }
    // }
    // const getRejectRemarkList = async (): Promise<any> => {
    //   return new Promise(async (resolve, reject) => {
    //     Get(DeclinedJobReasonListUrl)
    //       .then((response: any) => {
    //         if (response.success && response.data) {
    //           setRejectReasonRemarkList(response.data)
    //         }
    //         resolve(response)
    //       })
    //       .catch((getRejectRemarkListError) => {
    //         reject(getRejectRemarkListError);
    //       })
    //   })
    // }
    // const getProductWisePmParts = async () => {
    //   const requestBody = {
    //     "Usage": Number(ModuleDetailsGetById?.data?.ODOMeterReading),
    //     "VinNo": ModuleDetailsGetById?.data?.VinNo,
    //     "InstallBaseId": ModuleDetailsGetById?.data?.InstallBaseId,
    //     "RepairTypeId": ModuleDetailsGetById?.data?.RepairTypeId,
    //     "OrganizationId": selectedBranch?.OrganizationId,
    //   }
    //   let request: any = {
    //     RepairTypeId: ModuleDetailsGetById?.data?.RepairTypeId
    //   }
    //   if (parentModuleName === EParentModuleName.Appointment) {
    //     request.AppointmentId = parentModuleDocumentId
    //   }
    //   if (parentModuleName === EParentModuleName.ServiceEstimate) {
    //     request.EstimateId = parentModuleDocumentId
    //     request.VinNo = ModuleDetailsGetById?.data?.VinNo
    //     request.OrganizationId = selectedBranch?.OrganizationId
    //   }
    //   if (parentModuleName === EParentModuleName.Inspection) {
    //     request.InspectionId = parentModuleDocumentId
    //     request.VinNo = ModuleDetailsGetById?.data?.VinNo
    //     request.OrganizationId = selectedBranch?.OrganizationId
    //   }
    //   let declineJobRequestBody = {
    //     "ParentId": parentModuleDocumentId,
    //     "InstallBaseId": ModuleDetailsGetById?.data?.InstallBaseId,
    //     "ServiceDetailType": 3
    //   }
    //   const [response, SavedPmPartsResponse, declinedPmPartsResponse] = await Promise.all([
    //     dispatch(getListAPI({ key: "", url: PerodicPartsUrl, request: requestBody })),
    //     dispatch(getByIdAPI({ key: "", url: getSavedPeriodicPartsUrl, request: request })),
    //     dispatch(getListAPI({ key: "", url: getDeclinedPmParts, request: declineJobRequestBody }))
    //   ])
    //   let savedPmPartsList: Array<any> = []
    //   if (SavedPmPartsResponse.payload.success && SavedPmPartsResponse.payload.data?.PeriodicParts?.Labour?.length > 0 || SavedPmPartsResponse.payload.data?.PeriodicParts?.Part?.length > 0) {
    //     SavedPmPartsResponse?.payload?.data?.PeriodicParts?.Labour.map((item: any) => {
    //       let updatedItem = { ...item }
    //       updatedItem.jobType = "Labour"
    //       updatedItem.isExpanded = false
    //       savedPmPartsList.push(updatedItem)
    //     })
    //     SavedPmPartsResponse?.payload?.data?.PeriodicParts?.Part.map((item: any) => {
    //       let updatedItem = { ...item }
    //       updatedItem.jobType = "Part"
    //       updatedItem.isExpanded = false
    //       savedPmPartsList.push(updatedItem)
    //     })
    //   } else {
    //     setIsSkeleton(false)
    //   }
    //   if (response.payload.value.success && response.payload.value.data) {
    //     let masterPmPartsList: Array<any> = []
    //     response.payload.value.data?.Labour.map((item: any) => {
    //       let updatedItem = { ...item }
    //       updatedItem.jobType = "Labour"
    //       updatedItem.isExpanded = false
    //       masterPmPartsList.push(updatedItem)
    //     })
    //     response.payload.value.data?.Part.map((item: any) => {
    //       let updatedItem = { ...item }
    //       updatedItem.jobType = "Part"
    //       updatedItem.isExpanded = false
    //       masterPmPartsList.push(updatedItem)
    //     })
    //     setPmPartsMasterList(masterPmPartsList)
    //     if (declinedPmPartsResponse.payload?.value?.success && declinedPmPartsResponse.payload?.value?.data) {
    //       const declinesPmParts = declinedPmPartsResponse.payload?.value?.data ? declinedPmPartsResponse.payload?.value?.data : []
    //       setDeclinedPmPartsList(declinesPmParts)
    //       let finalList: Array<any> = []
    //       masterPmPartsList.map((masterItem: any) => {
    //         let isSaved = savedPmPartsList.find((savedItem: any) => savedItem.ChildId === masterItem.ChildId)
    //         let isDeclined = declinesPmParts.find((declinedItem: any) => declinedItem.ChildId === masterItem.ChildId)
    //         if (isSaved) {
    //           let updatedItem = { ...isSaved }
    //           updatedItem.isExpanded = false
    //           updatedItem.Quantity = masterItem.Quantity
    //           updatedItem.jobType = masterItem.jobType
    //           updatedItem.PartName = masterItem.jobType === "Part" ? masterItem.PartName : ""
    //           updatedItem.LabourName = masterItem.jobType === "Labour" ? masterItem.LabourName : ""
    //           updatedItem.Price = Number(masterItem?.Price ?? 0) * Number(masterItem?.Quantity)
    //           updatedItem.LabourCode = masterItem.jobType === "Labour" ? masterItem.LabourCode : ""
    //           updatedItem.PartCode = masterItem.jobType === "Part" ? masterItem.PartCode : ""
    //           finalList.push({ ...masterItem, ...updatedItem })
    //         }
    //         else if (isDeclined) {
    //           let updatedItem = { ...isDeclined }
    //           updatedItem.isExpanded = true
    //           updatedItem.DeclinedRemarks = updatedItem.Remarks ? updatedItem.Remarks : ""
    //           updatedItem.RejectReasonRemark = updatedItem.DeclinedJobReasonId ? updatedItem.DeclinedJobReasonId : ""
    //           updatedItem.jobType = masterItem.jobType
    //           updatedItem.PartName = masterItem.jobType === "Part" ? masterItem.PartName : ""
    //           updatedItem.LabourName = masterItem.jobType === "Labour" ? masterItem.LabourName : ""
    //           updatedItem.Quantity = masterItem.Quantity
    //           updatedItem.Price = Number(masterItem?.Price ?? 0) * Number(masterItem?.Quantity)
    //           updatedItem.LabourCode = masterItem.jobType === "Labour" ? masterItem.LabourCode : ""
    //           updatedItem.PartCode = masterItem.jobType === "Part" ? masterItem.PartCode : ""
    //           finalList.push(updatedItem)
    //         } else {
    //           let updatedItem = { ...masterItem }
    //           updatedItem.isExpanded = false
    //           updatedItem.Price = Number(masterItem?.Price ?? 0) * Number(masterItem?.Quantity)
    //           finalList.push(updatedItem)
    //         }
    //       })
    //       setIsSkeleton(false);
    //       setpmPartsList(finalList)
    //       let PmTotalPrice = 0
    //       finalList.map((item: any) => {
    //         if (!item?.isExpanded) {
    //           let amount = item?.Price ? item?.Price[0].MRP : 0
    //           PmTotalPrice += amount
    //         }
    //       })
    //       dispatch(setState({ key: "TotalPMPartPrice", value: PmTotalPrice }))
    //     }
    //     // setDisableSave(true)
    //   } else {
    //     setIsSkeleton(false)
    //   }
    // }
    var handleSelectPMPartsRejectReason = function (event, index) {
        var _event$target$value, _event$target;
        var updatedList = __spreadArray([], pmPartsList, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.RejectReasonRemark = (_event$target$value = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : "";
        updatedList[index] = updatedItem;
        setpmPartsList(updatedList);
        dispatch(setIsTaskDetailsDataUpdated(true));
        setDisableSave(false);
    };
    var handleChangeRejectRemark = function (event, index) {
        var _event$target$value2, _event$target2;
        var updatedList = __spreadArray([], pmPartsList, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.DeclinedRemarks = (_event$target$value2 = (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value) !== null && _event$target$value2 !== void 0 ? _event$target$value2 : "";
        updatedList[index] = updatedItem;
        setpmPartsList(updatedList);
        dispatch(setIsTaskDetailsDataUpdated(true));
        setDisableSave(false);
    };
    var savePMParts = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById2, _pmPartsList$filter, _ModuleDetailsGetById3, _ModuleDetailsGetById4, _checkModelWiseRespon, _ModuleDetailsGetById5, _saveDeclinedPmPartsR, _requestBody$Periodic, SavedPMParts, requestBody, declinedPMParts, partList, checkModelWisePayload, checkModelWiseResponse, saveDeclinedJobsPayload, saveDeclinedPmPartsResponse, filterPriceLabour, _response$payload, _response$payload2, response, _repeatAlertConfigura, _repeatAlertConfigura2, _repeatAlertConfigura3, updatedTaskDetailsSectionSave, sortedList_1, _ModuleDetailsGetById6, _ModuleDetailsGetById7, _ModuleDetailsGetById8, repeatBody, deleteRepeatPartsBody, checkRepeatResponse, _checkRepeatResponse$, _checkRepeatResponse$2, _checkRepeatResponse$3, _checkRepeatResponse$4, _checkRepeatResponse$5, deleteRepeatResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "PMParts_Save", undefined);
                    SavedPMParts = [];
                    pmPartsList.map(function (item) {
                        if (!item.isExpanded) {
                            var _ModuleDetailsGetById;
                            SavedPMParts.push({
                                Quantity: Number(item.Quantity),
                                SystemName: item.jobType === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                                VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById === void 0 ? void 0 : _ModuleDetailsGetById.VinNo,
                                ChildName: (item === null || item === void 0 ? void 0 : item.PartName) || item.LabourName,
                                ChildCode: (item === null || item === void 0 ? void 0 : item.SkuCode) || (item === null || item === void 0 ? void 0 : item.PartCode) || (item === null || item === void 0 ? void 0 : item.LabourCode) || "",
                                UnitOfMeasurementId: item.UnitOfMeasurementId,
                                Price: item.SelectedPriceDetails,
                                HSNSACCode: item.SelectedPriceDetails.HSNSACCode,
                                CDMSHSNSACCode: item.SelectedPriceDetails.CDMSHSNSACCode
                                // HSNSACCode: item.jobType === "Labour" ? item.SACCode : item.HSNCode,
                                // CDMSHSNSACCode: item.jobType === "Labour" ? item.CDMSSACCode : item.CDMSHSNCode
                            });
                        }
                    });
                    requestBody = {
                        "PeriodicParts": SavedPMParts,
                        "RepairTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById2 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById2 === void 0 ? void 0 : _ModuleDetailsGetById2.RepairTypeId
                    };
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        requestBody.EstimateId = parentModuleDocumentId;
                    }
                    if (parentModuleName === EParentModuleName.Appointment) {
                        requestBody.AppointmentId = parentModuleDocumentId;
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        requestBody.InspectionId = parentModuleDocumentId;
                    }
                    declinedPMParts = [];
                    pmPartsList.map(function (item) {
                        if (item.isExpanded) {
                            var _item$DeclinedRemarks;
                            declinedPMParts.push({
                                DeclineDateTime: new Date(),
                                Remarks: (_item$DeclinedRemarks = item.DeclinedRemarks) !== null && _item$DeclinedRemarks !== void 0 ? _item$DeclinedRemarks : "",
                                ServiceTypeId: item.ServiceTypeId,
                                DeclinedJobReasonId: item.RejectReasonRemark,
                                ParentSystemName: SystemName,
                                Quantity: item.Quantity,
                                SystemName: item.jobType === "Labour" ? "Labour" : "Product",
                                ChildId: item.ChildId,
                                ChildName: (item === null || item === void 0 ? void 0 : item.jobType) === "Part" ? item === null || item === void 0 ? void 0 : item.PartName : item === null || item === void 0 ? void 0 : item.LabourName,
                                ChildCode: (item === null || item === void 0 ? void 0 : item.jobType) === "Part" ? item === null || item === void 0 ? void 0 : item.PartCode : item === null || item === void 0 ? void 0 : item.LabourCode,
                                ServiceDetailType: 3,
                                Price: item === null || item === void 0 ? void 0 : item.SelectedPriceDetails,
                                HSNSACCode: item.SelectedPriceDetails.HSNSACCode,
                                CDMSHSNSACCode: item.SelectedPriceDetails.CDMSHSNSACCode
                                // HSNSACCode: item.jobType === "Labour" ? item.SACCode : item.HSNCode,
                                // CDMSHSNSACCode: item.jobType === "Labour" ? item.CDMSSACCode : item.CDMSHSNCode
                            });
                        }
                    });
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    partList = pmPartsList === null || pmPartsList === void 0 || (_pmPartsList$filter = pmPartsList.filter(function (item) { return !(item !== null && item !== void 0 && item.isExpanded) && (item === null || item === void 0 ? void 0 : item.jobType) === "Part"; })) === null || _pmPartsList$filter === void 0 ? void 0 : _pmPartsList$filter.map(function (item) { return item; });
                    checkModelWisePayload = {
                        SourceAssociationId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById3 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById3 === void 0 ? void 0 : _ModuleDetailsGetById3.ProductId,
                        PartList: partList,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        InstallBaseId: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById4 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById4 === void 0 ? void 0 : _ModuleDetailsGetById4.InstallBaseId
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            key: '',
                            url: checkModelWisePeriodicPartURL,
                            request: checkModelWisePayload
                        }))];
                case 1:
                    checkModelWiseResponse = _a.sent();
                    if (!(checkModelWiseResponse !== null && checkModelWiseResponse !== void 0 && (_checkModelWiseRespon = checkModelWiseResponse.payload) !== null && _checkModelWiseRespon !== void 0 && _checkModelWiseRespon.success)) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        return [2 /*return*/];
                    }
                    saveDeclinedJobsPayload = {
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById5 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById5 === void 0 ? void 0 : _ModuleDetailsGetById5.InstallBaseId,
                        "DeclinedJobs": declinedPMParts,
                        "ParentId": parentModuleDocumentId,
                        ServiceDetailType: 3
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "declinedPmParts",
                            url: saveDeclinedPmPartsURl,
                            request: saveDeclinedJobsPayload
                        }))];
                case 2:
                    saveDeclinedPmPartsResponse = _a.sent();
                    if (saveDeclinedPmPartsResponse && (_saveDeclinedPmPartsR = saveDeclinedPmPartsResponse.payload) !== null && _saveDeclinedPmPartsR !== void 0 && _saveDeclinedPmPartsR.value) {
                        setDeclinedPmPartsList(declinedPMParts);
                    }
                    filterPriceLabour = requestBody === null || requestBody === void 0 || (_requestBody$Periodic = requestBody.PeriodicParts) === null || _requestBody$Periodic === void 0 ? void 0 : _requestBody$Periodic.filter(function (item) {
                        var _item$Price;
                        return (item === null || item === void 0 ? void 0 : item.SystemName) === "Labour" && (!(item !== null && item !== void 0 && item.Price) || (item === null || item === void 0 || (_item$Price = item.Price) === null || _item$Price === void 0 ? void 0 : _item$Price.Amount) === 0);
                    });
                    if (!((filterPriceLabour === null || filterPriceLabour === void 0 ? void 0 : filterPriceLabour.length) > 0)) return [3 /*break*/, 3];
                    dispatch(showNotification({
                        isOpen: true,
                        message: /*#__PURE__*/ React.createElement("p", null, t("Price for each selected Labour Job items must be greater than zero"), /*#__PURE__*/ React.createElement("br", null)),
                        type: "error"
                    }));
                    return [3 /*break*/, 7];
                case 3: return [4 /*yield*/, dispatch(getListAPI({
                        key: "",
                        url: upsertPMPartsUrl,
                        request: requestBody
                    }))];
                case 4:
                    response = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (!(response !== null && response !== void 0 && (_response$payload = response.payload) !== null && _response$payload !== void 0 && (_response$payload = _response$payload.value) !== null && _response$payload !== void 0 && _response$payload.success && (response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.statusCode) == 200)) return [3 /*break*/, 7];
                    setDisableSave(true);
                    // getProductWisePmParts()
                    dispatch(setSavedTaskDetailsCount({
                        periodicMaintenanceCount: SavedPMParts.length
                    }));
                    dispatch(setState({
                        key: "getModuleHeaderCount",
                        value: _objectSpread(_objectSpread({}, getModuleHeaderCount), {}, {
                            PeriodicParts: SavedPMParts.length,
                            CustomerDeclinedJobs: declinedPMParts.length
                        })
                    }));
                    updatedTaskDetailsSectionSave = _objectSpread({}, TaskDetailsSectionSave);
                    updatedTaskDetailsSectionSave.periodicMaintainance = true;
                    dispatch(setState({
                        key: "TaskDetailsSectionSave",
                        value: updatedTaskDetailsSectionSave
                    }));
                    dispatch(setTaskDetailsDataSaved(true));
                    sortedList_1 = [];
                    updatedModuleSectionByChannel.map(function (item) {
                        var data = cloneDeep(item);
                        if (item.Key == EModuleSection.PeriodicMaintenance) {
                            // data.SectionAttributes[0].MANDATORY = response?.payload?.value?.data?.PeriodicParts?.length > 0 ? true : false
                            // data.SectionAttributes[0].MANDATORYDefaultValue = response?.payload?.value?.data?.PeriodicParts?.length > 0 ? true : false
                        }
                        sortedList_1.push(data);
                    });
                    dispatch(setUpdatedModuleSectionByChannel(sortedList_1));
                    dispatch(showNotification({
                        isOpen: true,
                        message: t("Periodic parts saved successfully"),
                        type: "success"
                    }));
                    if (!(repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura !== void 0 && _repeatAlertConfigura.Transaction && Array.isArray(repeatAlertConfiguration === null || repeatAlertConfiguration === void 0 || (_repeatAlertConfigura2 = repeatAlertConfiguration.data) === null || _repeatAlertConfigura2 === void 0 ? void 0 : _repeatAlertConfigura2.Transaction) && repeatAlertConfiguration !== null && repeatAlertConfiguration !== void 0 && (_repeatAlertConfigura3 = repeatAlertConfiguration.data) !== null && _repeatAlertConfigura3 !== void 0 && _repeatAlertConfigura3.Transaction.includes(SystemName))) return [3 /*break*/, 7];
                    repeatBody = {
                        "InstallBaseId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById6 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById6 === void 0 ? void 0 : _ModuleDetailsGetById6.InstallBaseId,
                        "CurrentODOMeterReading": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById7 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById7 === void 0 ? void 0 : _ModuleDetailsGetById7.ODOMeterReading,
                        "CurrentJobCardDate": moment().startOf('day'),
                        "CurrentJobCardParentOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.ParentOrganizationId,
                        "CurrentJobCardOrganizationId": selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        "CurrentJobCardRepairTypeId": ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById8 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById8 === void 0 ? void 0 : _ModuleDetailsGetById8.RepairTypeId,
                        "ParentId": parentModuleDocumentId !== null && parentModuleDocumentId !== void 0 ? parentModuleDocumentId : null,
                        "CurrentComplaints": [],
                        "CurrentParts": SavedPMParts.filter(function (item) { return item.SystemName === "Product"; }).map(function (item) { return item.ChildId; }),
                        "CurrentLabours": SavedPMParts.filter(function (item) { return item.SystemName === "Labour"; }).map(function (item) { return item.ChildId; })
                    };
                    deleteRepeatPartsBody = {
                        ParentId: parentModuleDocumentId,
                        Childs: declinedPMParts.map(function (item) {
                            return item.ChildId ? item.ChildId : item.id;
                        })
                    };
                    return [4 /*yield*/, dispatch(createAPI({
                            url: CheckRepeatUrl,
                            request: repeatBody
                        }))];
                case 5:
                    checkRepeatResponse = _a.sent();
                    if (showRepeatItems) {
                        if (checkRepeatResponse && checkRepeatResponse !== null && checkRepeatResponse !== void 0 && (_checkRepeatResponse$ = checkRepeatResponse.payload) !== null && _checkRepeatResponse$ !== void 0 && _checkRepeatResponse$.success && checkRepeatResponse !== null && checkRepeatResponse !== void 0 && (_checkRepeatResponse$2 = checkRepeatResponse.payload) !== null && _checkRepeatResponse$2 !== void 0 && _checkRepeatResponse$2.data) {
                            if (checkRepeatResponse !== null && checkRepeatResponse !== void 0 && (_checkRepeatResponse$3 = checkRepeatResponse.payload) !== null && _checkRepeatResponse$3 !== void 0 && (_checkRepeatResponse$3 = _checkRepeatResponse$3.data) !== null && _checkRepeatResponse$3 !== void 0 && _checkRepeatResponse$3.ChildAssociations && (checkRepeatResponse === null || checkRepeatResponse === void 0 || (_checkRepeatResponse$4 = checkRepeatResponse.payload) === null || _checkRepeatResponse$4 === void 0 || (_checkRepeatResponse$4 = _checkRepeatResponse$4.data) === null || _checkRepeatResponse$4 === void 0 ? void 0 : _checkRepeatResponse$4.ChildAssociations.length) > 0) {
                                showRepeatItems(checkRepeatResponse === null || checkRepeatResponse === void 0 || (_checkRepeatResponse$5 = checkRepeatResponse.payload) === null || _checkRepeatResponse$5 === void 0 || (_checkRepeatResponse$5 = _checkRepeatResponse$5.data) === null || _checkRepeatResponse$5 === void 0 ? void 0 : _checkRepeatResponse$5.ChildAssociations, SavedPMParts);
                            }
                        }
                    }
                    return [4 /*yield*/, dispatch(getListAPI({
                            url: deleteRepeatChildsURL,
                            request: deleteRepeatPartsBody
                        }))];
                case 6:
                    deleteRepeatResponse = _a.sent();
                    _a.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var onClickSave = function () {
        savePMParts();
    };
    var onClickAccordianIcon = function (index) {
        trackButtonClick("ButtonClickEvent", "PMS_Open_click", undefined);
        var updatedList = __spreadArray([], pmPartsList, true);
        var updatedItem = _objectSpread({}, updatedList[index]);
        updatedItem.isExpanded = !updatedItem.isExpanded;
        if (!updatedItem.isExpanded) {
            updatedItem.RejectReasonRemark = "";
            updatedItem.DeclinedRemarks = "";
        }
        updatedList[index] = updatedItem;
        if (!updatedItem.isExpanded) {
            setDisableSave(false);
        }
        setpmPartsList(updatedList);
        var PmTotalPrice = 0;
        updatedList.map(function (item) {
            if (!(item !== null && item !== void 0 && item.isExpanded)) {
                var _item$SelectedPriceDe, _item$SelectedPriceDe2;
                var amount = item !== null && item !== void 0 && (_item$SelectedPriceDe = item.SelectedPriceDetails) !== null && _item$SelectedPriceDe !== void 0 && _item$SelectedPriceDe.Amount ? item === null || item === void 0 || (_item$SelectedPriceDe2 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe2 === void 0 ? void 0 : _item$SelectedPriceDe2.Amount : 0;
                PmTotalPrice += amount;
            }
        });
        dispatch(setState({
            key: "TotalPMPartPrice",
            value: PmTotalPrice
        }));
    };
    var getSaveDisable = function () {
        var expandedItems = pmPartsList.filter(function (item) { return item.isExpanded; });
        if (expandedItems.length > 0) {
            var isAllReasonMandatoryValidated = Object.values(expandedItems).every(function (item) { return item.RejectReasonRemark; });
            var isRemarkMandatoryValidated = Object.values(expandedItems).every(function (item) { return item.DeclinedRemarks; });
            if (declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsReasonsMandatory && declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory) {
                return !(isAllReasonMandatoryValidated && isRemarkMandatoryValidated);
            }
            else if (declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsReasonsMandatory) {
                return !isAllReasonMandatoryValidated;
            }
            else if (declinedJobsConfiguration && declinedJobsConfiguration.IsRemarksMandatory) {
                return !isRemarkMandatoryValidated;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    var handleALternatePartClick = function (item) { return __awaiter(void 0, void 0, void 0, function () {
        var _ModuleDetailsGetById9, alterNatePartPayload, result, _result$payload$data, alternateParts, alternatePartItem, index, list;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    alterNatePartPayload = {
                        "PartId": item.ChildId,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        VinNo: ModuleDetailsGetById === null || ModuleDetailsGetById === void 0 || (_ModuleDetailsGetById9 = ModuleDetailsGetById.data) === null || _ModuleDetailsGetById9 === void 0 ? void 0 : _ModuleDetailsGetById9.VinNo
                    };
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "",
                            url: CheckAlterNatePartsUrl,
                            request: alterNatePartPayload
                        }))];
                case 1:
                    result = _a.sent();
                    dispatch(showLoader({
                        isLoaderOpen: false
                    }));
                    if (result && result.payload && result.payload.success) {
                        alternateParts = (_result$payload$data = result.payload.data) !== null && _result$payload$data !== void 0 ? _result$payload$data : [];
                        alternatePartItem = alternateParts.find(function (item) { return item.AssociationName === AlternatePartRelations.Superseds; });
                        if (alternatePartItem) {
                            index = pmPartsList.findIndex(function (pmPartItem) { return pmPartItem.ChildId === (item === null || item === void 0 ? void 0 : item.ChildId); });
                            if (index > 0) {
                                list = __spreadArray([], pmPartsList, true);
                                list[index] = _objectSpread(_objectSpread({}, list[index]), {}, {
                                    ChildId: alternatePartItem.PartId,
                                    PartName: alternatePartItem.PartName,
                                    HasAlternatePart: alternatePartItem.AssociationName === AlternatePartRelations.TwoWay
                                });
                                setpmPartsList(list);
                                dispatch(showNotification({
                                    isOpen: true,
                                    message: getSupersadeAlternatePartMessage(alternatePartItem.PartName, item.PartName),
                                    type: "success"
                                }));
                            }
                        }
                        else {
                            setAlterNatePartDetails(alternateParts);
                            setAlternetPartPopupOpen(alternateParts.length > 0);
                            setSearchedPart(_objectSpread(_objectSpread({}, item), {}, {
                                isChecked: true,
                                Name: item.PartName,
                                SkuCode: item.PartCode
                            }));
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var openJobDetailsDrawer = function (item, index) {
        setIsOpenJobItemDetailsDrawer(index);
        setSelectedJobItemDetails(item);
    };
    var handleClose = function (updatedItem) {
        var updatedList = __spreadArray([], pmPartsList, true);
        updatedList = updatedList.map(function (item) { return item.ChildId === updatedItem.ChildId ? updatedItem : item; });
        // if (isOpenJobItemDetailsDrawer) {
        //   updatedList[isOpenJobItemDetailsDrawer] = { ...updatedItem }
        // }
        setpmPartsList(updatedList);
        setIsOpenJobItemDetailsDrawer(null);
    };
    var showPrice = function (item) {
        var _item$SelectedPriceDe3;
        return ((_item$SelectedPriceDe3 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe3 === void 0 ? void 0 : _item$SelectedPriceDe3.Amount) || 0;
    };
    var AccordianActions = function (item, index) {
        var _showPrice, _item$SelectedPriceDe4, _item$SelectedPriceDe5, _item$SelectedPriceDe6;
        return /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: {
                xs: 0,
                md: 1
            },
            direction: {
                xs: 'row',
                md: 'row-reverse'
            },
            width: '100%',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingX: 2,
            paddingRight: IS_DESKTOP ? 0 : 2,
            paddingY: item.isExpanded ? 1 : 1.5
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            spacing: {
                xs: 0,
                md: 1
            },
            direction: {
                xs: 'row',
                md: 'row-reverse'
            },
            alignItems: 'center'
        }, (declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsAbleToDeclined) && /*#__PURE__*/ React.createElement(MuiStack, null, item.isExpanded ? /*#__PURE__*/ React.createElement(MuiButton, {
            onClick: function () { return onClickAccordianIcon(index); },
            variant: "text",
            endIcon: /*#__PURE__*/ React.createElement(ReverseActionIcon, null),
            name: "Add again",
            disabled: isDisabled,
            size: "small",
            sx: {
                backgroundColor: 'transparent',
                pl: 0,
                pr: 2,
                fontWeight: "medium",
                fontSize: 'base'
            },
            color: "primary",
            id: "add-again"
        }) : /*#__PURE__*/ React.createElement(MuiIconButton, {
            id: "".concat(item === null || item === void 0 ? void 0 : item.jobType, "-delete-btn"),
            disabled: isDisabled,
            onClick: function () { return onClickAccordianIcon(index); },
            sx: {
                mr: {
                    xs: 0
                },
                paddingLeft: IS_DESKTOP ? 1 : 0,
                opacity: isDisabled ? 0.5 : 1,
                justifyContent: 'end'
            }
        }, /*#__PURE__*/ React.createElement(RoundClearIcon, {
            id: "delete-btn-icon"
        }))), /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100px',
            justifyContent: {
                xs: 'left',
                md: 'center'
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "".concat(item.jobType, "-price"),
            textAlign: 'center',
            sx: {
                fontWeight: "medium",
                fontSize: 'lg',
                color: "text.primary",
                width: '10ch',
                display: 'flex',
                justifyContent: {
                    xs: 'start',
                    md: 'end'
                }
            }
        }, "\u20B9 ".concat((_showPrice = showPrice(item)) === null || _showPrice === void 0 ? void 0 : _showPrice.toFixed(2))))), /*#__PURE__*/ React.createElement(MuiStack, null, item.isExpanded ? /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: 'base',
                fontWeight: 'medium',
                color: "text.tertiary"
            }
        }, t('Qty'), ":"), /*#__PURE__*/ React.createElement(Typography, {
            sx: {
                fontSize: 'base',
                fontWeight: 'medium',
                color: "text.primary"
            }
        }, (_item$SelectedPriceDe4 = item === null || item === void 0 || (_item$SelectedPriceDe5 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe5 === void 0 ? void 0 : _item$SelectedPriceDe5.Quantity) !== null && _item$SelectedPriceDe4 !== void 0 ? _item$SelectedPriceDe4 : '-')) : /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(MuiStack, {
            height: '28px',
            width: '28px',
            justifyContent: 'center'
            // sx={{
            //   border: `1px solid`,
            //   borderColor: 'secondary.200',
            //   borderRadius: 0,
            //   borderTopLeftRadius: '4px',
            //   borderBottomLeftRadius: '4px'
            // }}
            ,
            sx: {
                border: "1px solid ".concat(systemColor.grey),
                borderRadius: 0,
                backgroundColor: '#F4F7FA',
                borderColor: 'secondary.200',
                borderTopLeftRadius: '4px',
                borderBottomLeftRadius: '4px'
            }
        }, /*#__PURE__*/ React.createElement(IconButton
        // onClick={() => handleDecrement(index)}
        , {
            size: "small"
            // disabled={isDisabled}
            ,
            disabled: true,
            id: "".concat(item.jobType, "-minus-btn")
        }, /*#__PURE__*/ React.createElement(GridRemoveIcon, {
            sx: {
                color: 'secondary.200'
            }
        }))), /*#__PURE__*/ React.createElement(TextField, {
            value: ((_item$SelectedPriceDe6 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe6 === void 0 ? void 0 : _item$SelectedPriceDe6.Quantity) || 0,
            variant: "outlined",
            size: "small",
            inputProps: {
                style: {
                    textAlign: 'center',
                    height: '25px',
                    padding: 0
                },
                inputMode: 'decimal',
                pattern: '[0-9]*[.,]?[0-9]*'
            },
            sx: {
                borderTop: "1px solid",
                borderBottom: "1px solid",
                borderColor: 'secondary.200',
                '& fieldset': {
                    border: 'none'
                },
                '& .MuiOutlinedInput-root': {
                    borderRadius: 0,
                    minWidth: '9ch'
                },
                '& .MuiInputBase-root': {
                    height: '25px',
                    width: '10ch'
                }
            },
            onChange: function (event) {
                // handleQuantityChange(
                //   event,
                //   index,
                //   item
                // )
                return null;
            },
            error: item.error
            // disabled={isDisabled}
            ,
            disabled: true,
            id: "".concat(item.jobType, "-qty"),
            type: "number"
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            height: '28px',
            width: '28px',
            justifyContent: 'center',
            sx: {
                border: "1px solid ".concat(systemColor.grey),
                borderRadius: 0,
                backgroundColor: '#F4F7FA',
                borderColor: 'secondary.200',
                borderTopRightRadius: '4px',
                borderBottomRightRadius: '4px'
            }
        }, /*#__PURE__*/ React.createElement(IconButton
        // onClick={() => handleIncrement(index)}
        , {
            size: "small"
            // disabled={isDisabled}
            ,
            disabled: true,
            id: "".concat(item === null || item === void 0 ? void 0 : item.jobType, "-plus-btn")
        }, /*#__PURE__*/ React.createElement(GridAddIcon, {
            sx: {
                color: 'secondary.200'
            }
        }))))));
    };
    return /*#__PURE__*/ React.createElement("div", null, pmPartsList.length > 0 ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        borderRadius: '8px',
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Grid, {
        spacing: 2,
        container: true
    }, pmPartsList === null || pmPartsList === void 0 ? void 0 : pmPartsList.map(function (item, index) {
        var _item$jobType, _item$jobType2, _item$RejectReasonRem, _item$DeclinedRemarks2;
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sm: 6,
            md: 12,
            key: index
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            sx: {
                "& .Mui-expanded": {
                    transform: "none",
                    backgroundColor: 'error.50',
                    borderRadius: '8px'
                },
                "& .MuiAccordionSummary-expandIconWrapper": {
                    height: '20px',
                    marginBottom: '50px'
                }
            },
            border: item.isExpanded ? "1px solid ".concat(Colors.error[500]) : 'none',
            bgcolor: item.isExpanded ? Colors.error[50] : 'white',
            borderRadius: '8px',
            boxShadow: '0px 0px 16px -4px rgba(16, 24, 40, 0.08)'
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 12
        }, /*#__PURE__*/ React.createElement(Accordion
        // variant='outlined'
        , {
            expanded: item.isExpanded,
            id: "pmParts-accordian-".concat(index),
            style: {
                width: '100%',
                boxShadow: 'none',
                borderRadius: '8px'
            }
        }, /*#__PURE__*/ React.createElement(AccordionSummary, {
            expandIcon: /*#__PURE__*/ React.createElement(MuiStack, {
                paddingTop: 3,
                alignItems: 'center',
                width: '100%'
            }, /*#__PURE__*/ React.createElement(Chip, {
                label: item === null || item === void 0 || (_item$jobType = item.jobType) === null || _item$jobType === void 0 ? void 0 : _item$jobType.substring(0, 1),
                id: item === null || item === void 0 || (_item$jobType2 = item.jobType) === null || _item$jobType2 === void 0 ? void 0 : _item$jobType2.substring(0, 1),
                color: "primary",
                variant: "filled",
                shape: "circular",
                sx: {
                    border: '1px solid #AFD5FF',
                    mr: 0.5
                }
            }), IS_DESKTOP && AccordianActions(item, index), /*#__PURE__*/ React.createElement(MuiIconButton, {
                id: "arrow-right-btn",
                onClick: function () { return openJobDetailsDrawer(item, index); },
                sx: {
                    p: 0.5
                }
            }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
                color: "primary",
                sx: {
                    height: '20px',
                    width: '20px'
                }
            }))),
            "aria-controls": "panel".concat(index, "a-content"),
            id: "panel".concat(index, "a-header")
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column',
            justifyContent: 'space-between',
            width: "100%",
            paddingRight: 1
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            alignItems: 'center',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(MuiCheckBox, {
            id: "service-type-checkbox",
            sx: {
                "& .MuiCheckbox-root": {
                    paddingY: 0,
                    paddingLeft: '8px',
                    paddingRight: '0px',
                    '&.Mui-disabled': {
                        color: item.isExpanded ? "secondary.400" : "success.300"
                    }
                }
            },
            disabled: true,
            checkBoxValue: true
        }), /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100%',
            spacing: 1.25,
            alignItems: 'center',
            justifyContent: 'space-between'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            direction: 'column'
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'flex-start',
            alignItems: "flex-start"
        }, /*#__PURE__*/ React.createElement(Typography, {
            id: "".concat(item === null || item === void 0 ? void 0 : item.jobType, "-name"),
            sx: {
                textTransform: 'capitalize',
                fontSize: 'base',
                fontWeight: 'medium',
                color: "text.primary"
            }
        }, item.PartName ? item.PartName : item.LabourName)), /*#__PURE__*/ React.createElement(MuiStack, {
            justifyContent: 'flex-start',
            alignItems: "flex-start",
            onClick: function () { }
        }, !item.isExpanded && item.HasAlternatePart && alternatePartConfigState["Periodic Maintenance"] && /*#__PURE__*/ React.createElement(MuiButton, {
            name: "Alternate Part",
            variant: "text",
            size: "small",
            sx: {
                bgcolor: "transparent",
                minWidth: 'auto',
                padding: 0
            },
            onClick: function () {
                handleALternatePartClick(item);
            }
        }))))), /*#__PURE__*/ React.createElement(Typography, {
            id: "".concat(item === null || item === void 0 ? void 0 : item.jobType, "-code"),
            sx: {
                fontSize: 'sm',
                fontWeight: 'mormal',
                color: "text.secondary"
            },
            marginLeft: '30px'
        }, item !== null && item !== void 0 && item.PartCode ? "#".concat(item === null || item === void 0 ? void 0 : item.PartCode) : "#".concat(item === null || item === void 0 ? void 0 : item.LabourCode)))), /*#__PURE__*/ React.createElement(AccordionDetails, {
            sx: {
                paddingX: 2,
                paddingB: 2,
                paddingTop: 0
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            width: '100%',
            spacing: 2,
            direction: {
                xs: 'column',
                md: 'row'
            }
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            flexDirection: 'column',
            width: '100%'
        }, /*#__PURE__*/ React.createElement(MuiSelectComponent, {
            id: "reject-reason-dropdown",
            margin: 0,
            fullWidth: true,
            options: rejectReasonRemarkList || [],
            caption: "reason for rejection",
            displayExpr: "DisplayName",
            valueExpr: "id",
            name: "rejectReason",
            value: (_item$RejectReasonRem = item.RejectReasonRemark) !== null && _item$RejectReasonRem !== void 0 ? _item$RejectReasonRem : "",
            onChange: function (event) { return handleSelectPMPartsRejectReason(event, index); },
            disabled: isDisabled,
            isMandatory: declinedJobsConfiguration === null || declinedJobsConfiguration === void 0 ? void 0 : declinedJobsConfiguration.IsReasonsMandatory
        })), /*#__PURE__*/ React.createElement(MuiStack, {
            flexDirection: 'column',
            width: '100%',
            mt: 0
        }, /*#__PURE__*/ React.createElement(InputBox
        // sx={{ height: '44px' }}
        , {
            id: "remark-input",
            placeholder: "".concat(t("ENTER_REMARKS_PLACEHOLDER"), " ").concat(declinedJobsConfiguration !== null && declinedJobsConfiguration !== void 0 && declinedJobsConfiguration.IsRemarksMandatory ? "*" : ""),
            onChange: function (event) { return handleChangeRejectRemark(event, index); },
            fullWidth: true,
            size: "small",
            value: (_item$DeclinedRemarks2 = item.DeclinedRemarks) !== null && _item$DeclinedRemarks2 !== void 0 ? _item$DeclinedRemarks2 : "",
            disabled: isDisabled
        })))))), !IS_DESKTOP && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(MuiStack, {
            paddingX: 2
        }, /*#__PURE__*/ React.createElement(Divider, {
            style: {
                width: '100%'
            }
        }))), !IS_DESKTOP && AccordianActions(item, index))));
    })))) : /*#__PURE__*/ React.createElement(React.Fragment, null, !isSkeleton && /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        paddingBottom: 2
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            fontSize: 'sm',
            fontWeight: 'mormal',
            color: "text.primary"
        }
    }, pmPartsMasterList.length > 0 && pmPartsMasterList.length === declinedPmPartsList.length ? t("ALL_PM_DECLINED_MESSAGE") : t("No Data Found"), "..!!")))), isSkeleton && /*#__PURE__*/ React.createElement(MuiStack, {
        spacing: 1,
        style: {
            height: '9vh',
            padding: '16px 16px 8px 16px'
        }
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null)), isSaveButton && /*#__PURE__*/ React.createElement(MuiStack, {
        width: '100%',
        justifyContent: "flex-end",
        marginTop: "10px"
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        id: "pm-parts-save",
        variant: "outlined",
        color: "primary",
        style: {
            width: "60px"
        },
        loading: loader.isLoaderOpen,
        name: t('Save'),
        disabled: getSaveDisable() || pmPartsList.length === 0 || isDisabled || disableSave,
        onClick: onClickSave
    })), /*#__PURE__*/ React.createElement(AlternatePartPopup, {
        alternetPartPopupOpen: alternetPartPopupOpen,
        setAlternetPartPopupOpen: setAlternetPartPopupOpen,
        replacePart: replacePart,
        searchedPart: searchedPart,
        setSearchedPart: setSearchedPart,
        alterNatePartDetails: alterNatePartDetails,
        setAlterNatePartDetails: setAlterNatePartDetails
    }), selectedJobItemDetails && /*#__PURE__*/ React.createElement(PartLabourDetailsDrawer, {
        jobItemDetails: selectedJobItemDetails,
        open: isOpenJobItemDetailsDrawer !== null,
        onClose: function (updatedItem) {
            handleClose(updatedItem);
        },
        SystemName: SystemName,
        isDisabled: true,
        jobItemType: EJobItemType.PeriodicMaintenance
    }));
};
export default PeriodicMaintainanceComponent;
